<template>
<div style="padding: 0 20px 30px">
  <div style="height: 40px">
    <el-button type="primary" size="mini" @click="addPerson">新增人员</el-button>
  </div>
  <div style="height: 400px">
    <el-table height="100%" v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="facePersonTable" border style="width: 100%" highlight-current-row>
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="enrollid" label="人员编号" width="90" align="center"></el-table-column>
      <el-table-column prop="name" label="人员名称" min-width="100" align="center"></el-table-column>
      <el-table-column label="性别" width="80" align="center">
        <template slot-scope="scope">
          <span>{{getSexDesc(scope.row.sex)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <i title="解绑" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delDevice(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div style="margin-top: 10px;height: 40px;text-align: center">
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                   layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
    </el-pagination>
  </div>
  <el-dialog :visible.sync="openShow" v-if="openShow" width="650px" :show-close="true" :close-on-click-modal="false"
    center append-to-body class="all-open">
    <div class="title-top-alarm">
      <div> <span>录入人员</span> </div>
      <div class="line-title"></div>
    </div>
    <div style="padding: 0 20px 30px">
      <div>
        <el-form size="mini" style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="录入人员" prop="name">
            <el-select v-fixZoom style="width: 100%" v-model="pid" placeholder="请选择" @change="selectPersonChange">
              <el-option v-for="item in selectpersonarr" :key="item.id" :label="item.person_name" :value="item.id">
                <span style="">{{ item.person_name }}</span> - <span style="color: #8492a6; font-size: 12px">{{ item.build_name }}/{{ item.floor_name }}/{{ item.room_name }}/{{ item.bed_name }}</span>
              </el-option>
            </el-select>
            <el-checkbox v-model="checkAll" @change="changeCheck">所有人员</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <div style="height: 30px;color: #999999">所选择录入人员</div>
        <el-table :data="personTable" border style="width: 100%" height="230px" highlight-current-row ref="singleTable" size="mini">
          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column prop="person_name" label="姓名" min-width="70" align="center"></el-table-column>
          <el-table-column label="性别" min-width="50" align="center">
            <template slot-scope="scope">
              <span>{{getSexDesc(scope.row.sex)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="所在床位" min-width="100" align="center">
            <template slot-scope="scope">
              <span>{{getBedDesc(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="50" align="center">
            <template slot-scope="scope">
              <el-button @click.native.prevent="deleteRow(scope.$index, personTable)" type="text" size="mini"> 移除 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-row style="margin: 0 20px">
          <el-col :span="12">
            <div class="cancel-btn" @click="openShow = !openShow">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitAdd('addEditForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {facepersonlist, facepersondelete, faceunusedenrollid, facepersonadd} from '../../../api/yanglaoyuan'
import {queryhomebedelderly} from '../../../api/yanglaoyuan/homebed'

export default {
  name: 'facePerson',
  model: {
    prop: 'detailsShow',
    event: 'change'
  },
  props: {
    faceObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      facePersonTable: [],
      isStart: true,
      openShow: false,
      radioType: 1,
      entityId: '',
      pid: '',
      selectpersonarr: [],
      personTable: [],
      checkAll: false,
      addEditForm: {
        devicesn: '',
        name: '',
        orgid: ''
      },
      addEditRules: {
        devicesn: [
          {required: true, message: '请输入门禁编号', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入门禁名称', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getPersonList()
  },
  mounted () {},
  methods: {
    // 查询入院列表
    getHomebedElderlyData () {
      if (!this.isStart) {
        this.getPersonSecl(this.selectpersonarr)
        return
      }
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        eid: this.entityId === 0 ? -1 : this.entityId,
        curent_state: [0, 1, 2]
      }
      queryhomebedelderly(params, data).then(res => {
        this.isStart = false
        this.getPersonSecl(res.data.homebedperson)
      })
    },
    getPersonSecl (arr) {
      console.log(123, arr)
      // let ids = []
      this.selectpersonarr = []
      // this.facePersonTable.forEach(item => {
      //   ids.push(item.personid)
      // })
      arr.forEach(item => {
        if (item.person_name === '测试') {
          console.log(item)
        }
        if (item.photo_url !== '') {
          this.selectpersonarr.push(item)
        }
      })
    },
    // 录入人员列表
    getPersonList () {
      this.loading = true
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        deviceid: this.faceObj.row.id // this.faceObj.row.id
      }
      facepersonlist(params, data).then(res => {
        this.loading = false
        this.totalCells = res.data.cnt
        this.facePersonTable = res.data.persons
        this.getHomebedElderlyData()
      }).catch(() => {
        this.loading = false
      })
    },
    // 获取性别描述
    getSexDesc (sex) {
      return this.util.getSex(sex + '')
    },
    // 获取所在床位
    getBedDesc (row) {
      let result = ''
      result = row.build_name + '/' + row.floor_name + '/' + row.room_name + '/' + row.bed_name
      return result
    },
    deleteRow (index, rows) {
      rows.splice(index, 1)
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getPersonList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getPersonList()
    },
    selectPersonChange () {
      let aa = true
      this.personTable.forEach(item => {
        if (this.pid === item.id) {
          aa = false
        }
      })
      if (aa) {
        this.selectpersonarr.forEach(item => {
          if (this.pid === item.id) {
            this.personTable.push(item)
          }
        })
      } else {
        this.$message({ message: '已存在录入人员。', ype: 'warning' })
      }
    },
    changeCheck () {
      if (this.checkAll) {
        this.personTable = this.selectpersonarr
      } else {
        this.personTable = []
      }
    },

    submitAdd () {
      if (this.personTable.length === 0) {
        this.$message({ message: '请选择录入人员', type: 'warning' })
      } else {
        this.getenrollidlist(this.personTable.length)
      }
    },
    getenrollidlist (cnt) {
      let data = {
        deviceid: this.faceObj.row.id,
        count: cnt
      }
      faceunusedenrollid(data).then(res => {
        if (res.data.enrollids.length > 0) {
          this.getSendList(res.data.enrollids)
        }
      }).catch(() => {})
    },
    async getSendList (arr) {
      for (let i = 0; i < this.personTable.length; i++) {
        await this.getData(this.personTable[i].photo_url, arr, i)
      }
      this.getPersonList()
      let vm = this
      setTimeout(() => {
        vm.openShow = false
      }, 300)
    },
    async getData (url, arr, i) {
      let listUrl = ''
      let vm = this
      await this.convertImageToBase64(url, base64 => {
        console.log(base64) // 输出图片的Base64编码
        listUrl = base64.split('base64,')
        // return listUrl
        vm.endSend(arr, listUrl, i)
      })
    },
    async endSend (arr, listUrl, i) {
      let data = {
        devicesn: this.faceObj.row.devicesn,
        enrollid: arr[i],
        name: this.personTable[i].person_name,
        backupnum: 50,
        admin: 0,
        personid: this.personTable[i].epid,
        staffid: 0,
        record: listUrl[1]
      }
      let num = i + 1
      await facepersonadd(data).then(res => {
        this.$message({ type: 'success', message: '成功添加' + num + '位人员', duration: 500 })
        this.getPersonList()
      }).catch(() => {})
    },
    async convertImageToBase64 (url, callback) {
      await fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const reader = new FileReader()
          reader.onload = e => callback(e.target.result)
          reader.readAsDataURL(blob)
        })
        .catch(error => console.error('Error converting image to Base64:', error))
    },

    addPerson () {
      this.pid = ''
      this.personTable = []
      this.openShow = true
    },
    delDevice (row) {
      let data = {
        deviceid: row.deviceid,
        enrollid: row.id,
        personid: row.personid,
        staffid: row.staffid
      }
      facepersondelete(data).then(res => {
        if (this.personTable.length === 1 && this.currentPage > 1) {
          this.currentPage--
        }
        this.$notify({title: '成功', message: '删除成功', type: 'success', duration: 2000})
        this.getPersonList()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/facePerson.vue